import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import AgentStatusDateHeader from './CallQueue/AgentStatusDateHeader'
import AgentStatusFilters from './CallQueue/AgentStatusFilters'
import AgentStatusTable from './CallQueue/AgentStatusTable'
import { useDashboardContext } from './context/DashboardContext'

export const AgentStatusPage = () => {
  const { t } = useTranslation()
  const { callCenterEnabled } = useDashboardContext()

  if (!callCenterEnabled) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Text>{t('dashboards.noDataAvailable')}</Text>
      </Flex>
    )
  }

  return (
    <>
      <AgentStatusFilters />
      <Flex
        padding="1.25rem"
        flexDirection="column"
        alignItems="center"
        gap="0.25rem"
        flex="1 0 0"
        alignSelf="stretch"
        overflow="auto"
      >
        <AgentStatusDateHeader />
        <AgentStatusTable />
      </Flex>
    </>
  )
}
